<template>
  <div>
    <!-- <button @click="handleDown">jsPDF方式下载</button>
    <button @click="handleWindowDown">浏览器打印</button> -->
    <div id="account-report">
      <table
        border="2"
        class="table-list"
        style="borderCollapse:collapse;border:1px solid #000000;font-size:16px;height:100%; "
      >
        <tbody>
          <tr style="height:64px">
            <th
              class="title"
              colspan="8"
              style="font-size: 18px;font-weight: 700"
            >结算确认单</th>
          </tr>
          <tr
            class="sub-title"
            style="height:48px"
          >
            <th
              colspan="4"
              class="text-left"
            >服务商名称（甲方）：<span>{{emptyTrans(dataObj.invoiceVO.invoiceTitle)}}</span>
            </th>
            <th
              v-if="dataObj.userType=='1'"
              colspan="4"
              class="text-left"
            >
              媒体名称（乙方）：{{emptyTrans(dataObj.paymentInfoVO.subjectName)}}</th>
            <th
              v-else
              colspan="4"
              class="text-left"
            >媒体名称（乙方）：{{emptyTrans(dataObj.paymentInfoVO.subjectName)}}</th>
          </tr>
          <tr style="height:48px">
            <th class="tw3">产品</th>
            <th class="tw2">官方包号</th>
            <th class="tw4">结算周期</th>
            <th class="tw2">有效数据</th>
            <th class="tw3">单价/比例</th>
            <th class="tw2">佣金(含税)</th>
            <th class="tw2">税点</th>
            <th class="tw2">佣金</th>
          </tr>
          <template
            v-if="isShow"
            v-for="(items,index) in dataContact"
          >
            <template v-for="(subItem,subIdx) in items">
              <tr
                v-if="subIdx=='0'"
                style="height:48px"
              >
                <th :rowspan="items.length">{{emptyTrans(subItem.productName)}}</th>
                <th :rowspan="items.length">{{emptyTrans(subItem.packageName)}}</th>
                <th :rowspan="items.length">{{areaDateTrans(subItem.startTime,subItem.endTime)}}</th>
                <th v-if="subItem.billingType=='263'">{{moneyTrans(subItem.trafficUserApprovalDataNums)}}</th>
                <th v-else>{{emptyTrans(subItem.trafficUserApprovalDataNums)}}</th>
                <!-- <th>{{moneyTrans(subItem.jdTrafficUserIntervalDataPriceList)}}</th> -->
                <th>{{moneyTrans(subItem.outPrice)}}</th>
                <th :rowspan="items.length">{{moneyTrans(subItem.trafficUserApprovalMoney)}}</th>
                <th :rowspan="items.length">{{moneyTrans(subItem.taxPoint)}}</th>
                <th :rowspan="items.length">{{moneyTrans(subItem.actualSettlementExpenditure)}}</th>
              </tr>
              <tr
                v-else
                style="height:48px"
              >
                <th v-if="subItem.billingType=='263'">{{moneyTrans(subItem.trafficUserApprovalDataNums)}}</th>
                <th v-else>{{emptyTrans(subItem.trafficUserApprovalDataNums)}}</th>
                <th>{{moneyTrans(subItem.outPrice)}}</th>
                <!-- <th>{{moneyTrans(subItem.approveMoney)}}</th> -->
              </tr>
            </template>
          </template>
          <!-- 表单汇总 -->
          <tr style="height:48px">
            <th>结算款总计</th>
            <th
              colspan="7"
              class="text-left"
              style="text-align: center"
            >￥{{moneyTrans(totalApproveMoney)}}</th>
          </tr>
          <!--结算款总结(含税)  -->
          <tr>
            <th>付款信息</th>
            <th colspan="7">
              <div
                class="text-left"
                style="text-align:left;padding-top:32px"
              >联系人：{{dataObj.paymentInfoVO.subjectName}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >账户名称：{{dataObj.paymentInfoVO.payee}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >开户行：{{dataObj.paymentInfoVO.openBankName}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >支行名称：{{dataObj.paymentInfoVO.branchBank}}</div>
              <div
                class="text-left"
                style="text-align:left;padding-bottom: 32px"
              >银行账号：{{dataObj.paymentInfoVO.payBank}}
              </div>
            </th>
            <!--开票信息 -->
          <tr>
            <th>开票信息</th>
            <th
              colspan="7"
              class="text-left"
            >
              <div
                class="text-left"
                style="text-align:left;padding-top:32px"
              > {{isSHowInvoiceTitle?'发票抬头信息：'+dataObj.invoiceVO.invoiceTitle:'&nbsp'}}
              </div>
              <div
                class="text-left"
                style="text-align:left;"
              >{{dataObj.invoiceVO.taxReceipt?'纳税人识别号：'+dataObj.invoiceVO.taxReceipt:'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >{{dataObj.invoiceVO.invoiceOpenBankName?'开户银行：'+dataObj.invoiceVO.invoiceOpenBankName:'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >{{dataObj.invoiceVO.invoicePayAccount?'银行账号：'+dataObj.invoiceVO.invoicePayAccount:'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >{{dataObj.invoiceVO.invoiceAddress?'地址电话：'+addreddPhoneTrans(dataObj.paymentInfoVO.payBody,dataObj):'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;padding-bottom: 32px"
              >{{dataObj.invoiceVO.invoiceRemark?'发票要求：'+dataObj.invoiceVO.invoiceRemark:'&nbsp'}}
              </div>

            </th>
          </tr>
          <!-- 快递单信息 -->
          <tr>
            <th style="width: 200px">发票、结算单快递信息</th>
            <th
              colspan="7"
              class="text-left"
            >
              <div
                class="text-left"
                style="text-align:left;padding-top:32px"
              > {{dataObj.receiveInfoVO.recipients?'收件人：'+emptyTrans(dataObj.receiveInfoVO.recipients):'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;"
              >{{dataObj.receiveInfoVO.receivePhone?'电话：'+emptyTrans(dataObj.receiveInfoVO.receivePhone):'&nbsp'}}</div>
              <div
                class="text-left"
                style="text-align:left;padding-bottom:32px"
              >{{dataObj.receiveInfoVO.receiveAddress?'收件地址：'+emptyTrans(dataObj.receiveInfoVO.receiveAddress):'&nbsp'}}
              </div>
            </th>
          </tr>
          <tr
            class="no-border"
            style="padding-top:24px;"
          >
            <th
              colspan="8"
              class="text-left"
            >
              <div style="padding-left:40px;margin-top:32px">
                请在收到《结算确认单》后进行核查，确认本期结算金额准确无误，特此确认！
              </div>
              <div style="padding-left:40px;margin-bottom: 32px">
                确认无误后盖章（一式两份）并快递至如上地址。
              </div>
            </th>
          </tr>
          <!-- 落款 -->
          <tr class="no-border">
            <th>甲方：</th>
            <th
              colspan="2"
              class="text-left"
            >{{emptyTrans(dataObj.invoiceVO.invoiceTitle)}}</th>
            <th>乙方：</th>
            <th
              v-if="dataObj.userType=='1'"
              colspan="4"
              class="text-left"
            >
              {{emptyTrans(dataObj.paymentInfoVO.subjectName)}}</th>
            <th
              v-else
              colspan="4"
              class="text-left"
            >{{emptyTrans(dataObj.paymentInfoVO.subjectName)}}</th>
          </tr>
          <tr class="no-border">

            <th style="padding-bottom: 100px">日期：</th>
            <th
              colspan="2"
              class="text-left"
              style="padding-bottom: 100px"
            >{{getToday()}}</th>
            <th style="padding-bottom: 100px">日期：</th>
            <th
              colspan="4"
              class="text-left"
              style="padding-bottom: 100px"
            >{{getToday()}}</th>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
// import htmlToPdf from './pdf';
import "./pdf.css"
import windowPrint from './windowPrint'
import { getToday, emptyTrans, formatMoney, getDictList, areaDateTrans } from '@/api/dataTrans'
export default {
  props: ['dataobj'],
  data () {
    return {
      // dataObj: { "companyName": null, "userType": null, "list": [], "totalApproveMoney": null, "siterUser": { "companyName": null, "contactName": null, "accountName": null, "bankName": null, "bankBranchName": null, "bankAccount": null }, "payUser": { "invoiceHeader": null, "invoiceHeaderStr": null, "payTaxesNum": null, "bankName": null, "bankAccount": null, "addressTell": null, "invoiceRequire": null }, "other": { "receiptUser": null, "phone": null, "receiptAddress": null } }
      dataObj: {
        isSHowInvoiceTitle: false,
        //收款信息
        paymentInfoVO: {
          subjectId: null,
          subjectName: null,
          subjectType: null,
          taxPoint: null,
          invoiceContent: null,
          invoiceName: null,
          payBank: null,
          payee: null,
          openBankName: null,
          branchBank: null,
          payBody: null
        },
        //发票信息
        invoiceVO: {
          invoiceTitle: null,
          taxReceipt: null,
          invoicePhone: null,
          invoiceAddress: null,
          invoiceRemark: null,
          invoiceOpenBankName: null,
          invoicePayAccount: null,
          invoices: [{
            invoiceAmount: null,
            invoiceCode: null,
          }]
        },
        //收款信息
        receiveInfoVO: {
          recipients: null,
          receiveAddress: null,
          receivePhone: null
        },
        //结算区间列表数据
        dataContact: [[]],
        //结算款总额
        totalApproveMoney: "0",
      },
      isShow: false,
      bodyList: [],
    }
  },
  methods: {
    //空字串转换
    emptyTrans (_val) {
      return emptyTrans(_val)
    },
    //货币格式转换
    moneyTrans (_val) {
      return formatMoney(_val)
    },
    //获取今天日期
    getToday () {
      return getToday()
    },
    // js打印
    // handleDown () {
    //   htmlToPdf.downloadPDF(document.querySelector('#account-report'), '对账单');
    // },
    // 浏览器打印
    handleWindowDown () {
      const _this = this
      windowPrint.handleWindowPrint('#account-report', '对账单');
    },
    initdata (dataobj) {
      const _this = this
      this.bodyList = getDictList(257);
      // console.log(JSON.stringify(dataobj))
      //付款信息
      _this.dataObj.paymentInfoVO = dataobj.paymentInfoVO
      //发票信息
      if (dataobj.invoiceVO) {
        _this.dataObj.invoiceVO = dataobj.invoiceVO
      }
      if (dataobj.paymentInfoVO.subjectType == 2) {
        _this.isSHowInvoiceTitle = false
        _this.dataObj.invoiceVO.invoiceTitle = _this.bodyTrans(dataobj.paymentInfoVO.payBody);
      } else {
        _this.isSHowInvoiceTitle = true
      }
      //结算区间数据合并
      if (dataobj.settlementDataList) {
        _this.dataContact = _this.tableContactTrans(dataobj.settlementDataList, null)
      } else {
        _this.dataContact = _this.tableContactTrans(null, dataobj.paymentDataList)
      }
      this.isShow = true
      //收件信息
      if (dataobj.receiveInfoVO) {
        _this.dataObj.receiveInfoVO = dataobj.receiveInfoVO
      }
      setTimeout(function () {
        _this.handleWindowDown()
        _this.$emit('callback', null)
      }, 500)
    },
    //区间结算数据合并
    tableContactTrans (_obj, arr2) {
      var _result = [], _count = 0;
      if (_obj) {
        if (_obj.amountSettlement) {
          _count = _count + _obj.amountSettlement
        }
        _result = _obj.jdTrafficIntervalDataVOList
      }
      if (arr2) {
        arr2.forEach(items => {
          if (items.jdTrafficIntervalDataVOList) {
            items.jdTrafficIntervalDataVOList.forEach(subItems => {
              _result.push(subItems);
            })
          }
          if (items.amountSettlement) {
            _count = _count + items.amountSettlement
          }
        })
      }
      this.totalApproveMoney = _count
      return this.transMediaData(_result)
    },
    // 流量主区间数据转换
    transMediaData (_dataArr) {
      var _arr = _dataArr;
      let newData = {};
      _arr.forEach((e) => {
        if (Object.keys(newData).indexOf("" + e.intervalTag) === -1) {
          newData[e.intervalTag] = [];
        }
        newData[e.intervalTag].push(e);
      });
      var arrArr = [];
      Object.keys(newData).forEach((items) => {
        arrArr.push(newData[items]);
      });
      this.isArea = true;
      return arrArr;
    },
    //结算周期转换
    dateTrans (date1, data2) {
      if (date1) {
        if (data2) {
          return date1 + '至' + data2
        } else {
          return date1 + '至今'
        }
      } else {
        return "--"
      }
    },
    //地址电话转换（深圳鲸鱼）
    addreddPhoneTrans (_val, _dataObj) {
      var _result = '--'
      if (_val == '341') {
        _result = _dataObj.invoiceVO.invoiceAddress
      } else {
        _result = _dataObj.invoiceVO.invoiceAddress + _dataObj.invoiceVO.invoicePhone
      }
      return _result
    },
    areaDateTrans (date1, date2) {
      return areaDateTrans(date1, date2, true)
    },
    // 支付主体转换
    bodyTrans (_val) {
      var _result = "--";
      this.bodyList.forEach(items => {
        if (_val = items.id) {
          _result = items.name;
        }
      });
      return _result;
    },
    staticData () {
      return _data
    },
  }
}
</script>
<style>
tr {
  height: 60px;
}
</style>